<div class="space"></div>

<div class="lightgray">
	<div class="slider">
		<div class="slide">
			<div class="somos">
				<div class="wrapper">
					<img class="caja" src="../../../../../assets/img/box.webp" alt="">
					<div class="info anime-element fadeleft-animation">
						<div class="gtitle">
							<img class="igoogle" src="../../../../../assets/img/igoogle.svg" alt=""> 
							<h2>Workspace</h2>
						</div>
						<div class="fluid">
							<div class="piece">
								<ul>
									<li>{{ 'cloud.title282' | translate }}</li>
									<li>{{ 'cloud.title283' | translate }}</li>
									<li>{{ 'cloud.title284' | translate }}</li>
									<li>{{ 'cloud.title285' | translate }}</li>
								</ul>	
							</div>
						</div>
						
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="space"></div>

<img class="wave" src="../../../../../assets/img/bg-wave.svg" alt="">
<div class="content-area">  
    
    <div class="wrap">
		
		<section id="credenciales">
			<div class="flex6">
				<div class="element6">
					<div class="fluid">

						<div class="piece">
							<img class="number" src="../../../../../assets/img/workspace/migrado.svg" alt="">
						</div>
						<div class="piece">
                            <div class="base">
							     <h3>{{ 'cloud.title286' | translate }}</h3>
							     <p>{{ 'cloud.title287' | translate }}</p>
                            </div>
						</div>
					</div>
				</div>
				<div class="element6">
					<div class="fluid">
						<div class="piece">
							<img class="number" src="../../../../../assets/img/workspace/cambio.svg" alt="">
						</div>
						<div class="piece">
                            <div class="base">
                            	<h3>{{ 'cloud.title288' | translate }}</h3>
                                <p>{{ 'cloud.title289' | translate }}</p>
                            </div>
						</div>
					</div>
				</div>
				<div class="element6">
					<div class="fluid">
						<div class="piece">
							<img class="number" src="../../../../../assets/img/workspace/bank.svg" alt="">
						</div>
						<div class="piece">
                            <div class="base">
                            	<h3>{{ 'cloud.title290' | translate }}</h3>
							    <p>{{ 'cloud.title291' | translate }}</p>
                            </div>
						</div>
					</div>
				</div>
				<div class="element6">
					<div class="fluid">
						<div class="piece">
							<img class="number" src="../../../../../assets/img/workspace/integracion.svg" alt="">
						</div>
						<div class="piece">
                            <div class="base">
                            	<h3>{{ 'cloud.title292' | translate }}</h3>
							    <p>{{ 'cloud.title293' | translate }}</p>
                            </div>
						</div>
					</div>
				</div>
				<div class="element6">
					<div class="fluid">
						<div class="piece">
							<img class="number" src="../../../../../assets/img/workspace/journey.svg" alt="">
						</div>
						<div class="piece">
                            <div class="base">
                            	<h3>{{ 'cloud.title294' | translate }}</h3>
							    <p>{{ 'cloud.title295' | translate }}</p>
                            </div>
						</div>
					</div>
				</div>
			</div>
			
		</section>


	</div>
</div>



<div id="primary" class="content-area">
	<img class="lines" src="../../../../../assets/img/lines.svg" alt="">
	<img class="shape" src="../../../../../assets/img/shape.svg" alt="">
	<div class="wrap">

	

	<section class="section">
		<div class="container">

			<div class="columns">
				<div class="column is-offset-1">
					<div class="tabs is-medium is-uppercase" id="sensor-tabs">
						<ul>
							<li class="is-active" data-tab="1">
								<a class="iflex">
									<div class="high">
										<img class="mail" src="../../../../../assets/img/mail.svg" alt="google mail">
									</div>
									<div class="low">
										<span>Google Mail</span>
									</div>
									
									
								</a>
							</li>
							<li data-tab="2">
								<a class="iflex">
									

									<div class="high">
										<img class="drive" src="../../../../../assets/img/drive.svg" alt="google drive">
									</div>
									<div class="low">
										<span>Google Drive</span>
									</div>
								</a>
							</li>
							<li data-tab="3">
								<a class="iflex">
									<div class="high">
										<img class="vault" src="../../../../../assets/img/avault.svg" alt="google vault">
									</div>
									<div class="low">
										<span>Google Vault</span>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="columns is-centered">
				<div class="column is-10">
					<div id="sensor-tab-content" class="tab-content">
						<menu data-content="1">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title296' | translate }}</p>
								<ul>
									<li>{{ 'cloud.title297' | translate }}</li>
									<li>{{ 'cloud.title298' | translate }}</li>
									<li>{{ 'cloud.title299' | translate }}</li>
									<li>{{ 'cloud.title300' | translate }}</li>
								</ul>
							</div>
						</menu>
						<menu data-content="2">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title301' | translate }}</p>
								<ul>
									<li>{{ 'cloud.title302' | translate }}</li>
									<li>{{ 'cloud.title303' | translate }}</li>
								</ul>
							</div>
						</menu>
						<menu data-content="3">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title304' | translate }}</p>
								<ul>
									<li>{{ 'cloud.title305' | translate }}</li>
								</ul>
							</div>
						</menu>
					</div>
				</div>
			</div>

		</div>
	</section>


	<section class="section">
		<div class="container">

			<div class="columns">
				<div class="column is-offset-1">
					<div class="tabs is-medium is-uppercase" id="platform-tabs">
						<ul>
							<li class="is-active" data-tab="calendar">
								<a class="iflex">
									<div class="high">
										<img class="calendar" src="../../../../../assets/img/calendar.svg" alt="google calendar">
									</div>
									<div class="low">
										<span>Google Calendar</span>
									</div>
								</a>
							</li>
							<li data-tab="sites">
								<a class="iflex">
									

									<div class="high">
										<img class="sites" src="../../../../../assets/img/sites.svg" alt="google sites">
									</div>
									<div class="low">
										<span>Google Sites</span>
									</div>
								</a>
							</li>
							<li data-tab="groups">
								<a class="iflex">
									<div class="high">
										<img class="groups" src="../../../../../assets/img/groups.svg" alt="google groups">
									</div>
									<div class="low">
										<span>Google Groups</span>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="columns is-centered">
				<div class="column is-10">
					<div id="sensor-tab-content" class="tab-content">
						<menu data-content="calendar">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title306' | translate }}<p>
								<span>{{ 'cloud.title307' | translate }}</span>
							</div>
						</menu>
						<menu data-content="sites">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title308' | translate }}</p>
								<span>{{ 'cloud.title309' | translate }}</span>
							</div>
						</menu>
						<menu data-content="groups">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title310' | translate }}</p>
								<ul>
									<li>{{ 'cloud.title311' | translate }}</li>
									<li>{{ 'cloud.title312' | translate }}</li>
									<li>{{ 'cloud.title313' | translate }}</li>
									<li>{{ 'cloud.title314' | translate }}</li>
								</ul>
							</div>
						</menu>
					</div>
				</div>
			</div>

		</div>
	</section>

	<section class="section">
		<div class="container">

			<div class="columns">
				<div class="column is-offset-1">
					<div class="tabs is-medium is-uppercase" id="platform-tabs">
						<ul>
							<li class="is-active" data-tab="chat">
								<a class="iflex">
									<div class="high">
										<img class="chat" src="../../../../../assets/img/chat.svg" alt="google chat">
									</div>
									<div class="low">
										<span>Google Chat</span>
									</div>
								</a>
							</li>
							<li data-tab="meet">
								<a class="iflex">
									

									<div class="high">
										<img class="meet" src="../../../../../assets/img/meet.svg" alt="google meet">
									</div>
									<div class="low">
										<span>Google Meet</span>
									</div>
								</a>
							</li>
							<li data-tab="forms">
								<a class="iflex">
									<div class="high">
										<img class="forms" src="../../../../../assets/img/forms.svg" alt="google forms">
									</div>
									<div class="low">
										<span>Google Forms</span>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="columns is-centered">
				<div class="column is-10">
					<div id="sensor-tab-content" class="tab-content">
						<menu data-content="chat">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title315' | translate }}</p>

								<span>{{ 'cloud.title316' | translate }}</span>
							</div>
						</menu>
						<menu data-content="meet">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title317' | translate }}</p>

								<span>{{ 'cloud.title318' | translate }}</span>
							</div>
						</menu>
						<menu data-content="forms">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title319' | translate }}</p>
								<span>{{ 'cloud.title320' | translate }}</span>
							</div>
						</menu>
					</div>
				</div>
			</div>

		</div>
	</section>


	<section class="section">
		<div class="container">

			<div class="columns">
				<div class="column is-offset-1">
					<div class="tabs is-medium is-uppercase" id="platform-tabs">
						<ul>
							<li class="is-active" data-tab="docs">
								<a class="iflex">
									<div class="high">
										<img class="docs" src="../../../../../assets/img/docs.svg" alt="google docs">
									</div>
									<div class="low">
										<span>Google Docs</span>
									</div>
								</a>
							</li>
							<li data-tab="sheets">
								<a class="iflex">
									

									<div class="high">
										<img class="sheets" src="../../../../../assets/img/sheets.svg" alt="google sheets">
									</div>
									<div class="low">
										<span>Google Sheets</span>
									</div>
								</a>
							</li>
							<li data-tab="slides">
								<a class="iflex">
									<div class="high">
										<img class="slides" src="../../../../../assets/img/slides.svg" alt="google slides">
									</div>
									<div class="low">
										<span>Google Slides</span>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="columns is-centered">
				<div class="column is-10">
					<div id="sensor-tab-content" class="tab-content">
						<menu data-content="docs">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title321' | translate }}</p>
								<span>{{ 'cloud.title322' | translate }}</span>
							</div>
						</menu>
						<menu data-content="sheets">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title323' | translate }}</p>
								<span>{{ 'cloud.title324' | translate }}</span>
							</div>
						</menu>
						<menu data-content="slides">
							<div class="columns is-multiline">
								<p>{{ 'cloud.title325' | translate }}</p>
								<span>{{ 'cloud.title326' | translate }}</span>
							</div>
						</menu>
					</div>
				</div>
			</div>

		</div>
	</section>
	</div>
</div>
		
<div class="space"></div>
<div class="space2"></div>




<div class="fondo">
<div class="content-area">
	<div class="wrap">


    <div class="padd">

    	<img class="aro" src="../../../../../assets/img/aro.svg" alt="">
    	
	    <div class="padded">
			<div class="title">
				<h3>{{ 'cloud.title327' | translate }}</h3>
			</div>
		</div>

    	<table>
		  <caption></caption>
		  <thead>
		    <tr>
		      <th scope="col">{{ 'cloud.title328' | translate }}</th>
		      <th scope="col">Google Workspace</th>
		      <th scope="col">{{ 'cloud.title329' | translate }}</th>
		      <th scope="col">{{ 'cloud.title330' | translate }}</th>
		    </tr>
		  </thead>
		  <tbody>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title331' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners">
		      	<img class="tick" src="../../../../../assets/img/tick.svg" alt="">
		      </td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title332' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title333' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title334' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title335' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title336' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title337' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title338' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title339' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title340' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title341' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title342' | translate }}</td>
		      <td data-label="Google Workspace"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title343' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title344' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title345' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title346' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title347' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title348' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title349' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title350' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title351' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title352' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title353' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title354' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title355' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		    <tr>
		      <td data-label="Funcionalidad">{{ 'cloud.title356' | translate }}</td>
		      <td data-label="Google Workspace"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		      <td data-label="Google Workspace con eSource"><img class="tick" src="../../../../../assets/img/tick.svg" alt=""></td>
		      <td data-label="Google Workspace con otros partners"><img class="equis" src="../../../../../assets/img/equis.svg" alt=""></td>
		    </tr>
		  </tbody>
		</table>

    </div>
	</div>
</div>
</div>

<div (click)="scroll(ibox)">
	<app-banner></app-banner>
</div>




<div class="space"></div>
	
<div id="primary" class="content-area">
	<div class="wrap">

		<section class="vc_section">

			<div class="flex6 website">
				<div class="elementb box">
					<div class="high">
						<img class="icloud" src="../../../../assets/img/cloud.svg" alt="">
						<div class="table">
							<div><p>+</p></div>
							<div class="cell figure">
							    <span>350</span>
							</div>
							<div class="min"><span>K</span></div>
						</div>
						
					</div>
					<div class="low">
						<h3>{{ 'cloud.title357' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high center">
						<img class="partner" src="../../../../../assets/img/partner1.svg" alt="">
					</div>
					<div class="low mid">
						<h3>{{ 'cloud.title358' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<img class="imoon" src="../../../../../assets/img/monitor.svg" alt="">
						<div class="table">
							<div class="cell figure">
							    <span>24x7</span>
							</div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title359' | translate }}</h3>
					</div>
				</div>
				<div class="elementb box">
					<div class="high">
						<img class="imoon" src="../../../../../assets/img/monitor.svg" alt="">
						<div class="table">
							<div><p>+</p></div>
							<div class="cell figure">
							    <span>1</span>
							</div>
							<div class="min"><span>M</span></div>
						</div>
					</div>
					<div class="low">
						<h3>{{ 'cloud.title360' | translate }}</h3>
					</div>
				</div>
			</div>

		</section>

	</div>
</div>	

<div class="space"></div>

<div class="gray">
	<div class="content-area">
		<div class="wrap">
			<section class="video">
				<div class="w100">
					<div class="frame">
						<div class="center">
<!-- 							<iframe width="640" height="360" id="frame" frameborder="0" src="https://www.youtube.com/embed/4oP20QZxahk" [src]="current_url" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> -->


<iframe width="640" height="360" id="frame" frameborder="0" src="https://www.youtube.com/embed/4oP20QZxahk" [src]="iframeService.srcObservable$ | async" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>


<!-- 							<div class="pairs">
								<button md-button (click)="updateSrc(first_url)" id="first" class="top-link">Video en español</button>
								<button md-button (click)="updateSrc(second_url)" id="second" class="top-link">Video in english</button>
							</div> -->
						</div>
						
					</div>
					
				</div>
			</section>	
		</div>
	</div>
</div>



<div id="primary" class="content-area">
	<div class="wrap">
		<section class="casos">
			<div class="section-header">
				<div class="wp_column vc_column_container">
					<div class="vc-column">
						<h2>{{ 'cloud.title361' | translate }}</h2>
						<p></p>
					</div>
				</div>
			</div>

			<div class="flex8">
				<div class="box8">
					<div class="grid">
						<figure class="effect-lily trigger">
							<div class="circle">
								<img class="splus" src="../../../../../assets/img/plus.svg" alt="">
							</div>
							<img src="../../../../../assets/img/21epasa.webp" alt="img24"/>
							<figcaption>
								<div>
									<h2>Grupo Epasa</h2>
									<p>{{ 'cloud.title362' | translate }}</p>
								</div>
							</figcaption>			
						</figure>
					</div>
				</div>
				<div class="box8">
					<div class="grid">
						<figure class="effect-lily trigger">
							<div class="circle">
								<img class="splus" src="../../../../../assets/img/plus.svg" alt="">
							</div>
							<img src="../../../../../assets/img/21pit.webp" alt="img24"/>
							<figcaption>
								<div>

									<h2>Grupo PIT</h2>
									<p>{{ 'cloud.title363' | translate }}</p>
								</div>
							</figcaption>			
						</figure>
					</div>
				</div>
				<div class="box8">
					<div class="grid">
						<figure class="effect-lily trigger">
							<div class="circle">
								<img class="splus" src="../../../../../assets/img/plus.svg" alt="">
							</div>
							<img src="../../../../../assets/img/21alqueria.webp" alt="img24"/>
							<figcaption>
								<div>
									<h2>Alquería</h2>
									<p>{{ 'cloud.title364' | translate }}</p>
								</div>
							</figcaption>			
						</figure>
					</div>
				</div>
			</div>

		</section>
	</div>
</div>

		
<div class="modal">
  <div class="modal-content">
  	<span class="btn-close" (click)='closeVideo()'>
  		<img src="../../../../../assets/img/close.svg" alt="close">
  	</span>
    	<iframe id="player" class="iframe" src="https://www.youtube.com/embed/EUjWFr3w7RU" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</div>
<div class="modal">
  <div class="modal-content">
  	<span class="btn-close" (click)='closeVideo1()'>
  		<img src="../../../../../assets/img/close.svg" alt="close">
  	</span>
    	<iframe id="player1" class="iframe" src="https://www.youtube.com/embed/702Hn_tU4FE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</div>
<div class="modal">
  <div class="modal-content">
  	<span class="btn-close" (click)='closeVideo2()'>
  		<img src="../../../../../assets/img/close.svg" alt="close">
  	</span>
    	<iframe id="player2" class="iframe" src="https://www.youtube.com/embed/tOxm9xUBKvI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</div>



<div class="content-area">
	<div class="wrap">
		<section class="intereses">
			<div class="wrapper">
	            <h3>{{ 'cloud.title365' | translate }}</h3>
	            <div class="card-wrapper">
	                <div class="card" routerLink="/gcp">
	                    <img class="ncloud" src="../../../../../assets/img/gplatform.svg" alt="Cloud">
	                    <img class="arrow" src="../../../../assets/img/blue-arrow.svg" alt="arrow">
	                </div>
	                <div class="card" routerLink="/maps">
	                    <img class="img-icon" src="../../../../../assets/img/gmaps.svg" alt="Maps">
	                    <img class="arrow" src="../../../../assets/img/blue-arrow.svg" alt="arrow">
	                </div>
	            </div>
	        </div>
		</section>
	</div>
</div>



<div style="margin-bottom: -40px;">
	<div #ibox>
		<app-form></app-form>
	</div>
</div>
			
			

		
	





